module.exports = __webpack_public_path__ + "img/Villa_Borna_33.48cdc99d.jpg";